import _ from 'lodash';
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import { getGlobalClasses } from '../../themes';
import driverReportIcon from '../../images/icons/driverReport.svg';
import { Link } from 'react-router-dom';
import requireClockIn from '../../components/timeClock/requireClockIn';

const styles = (theme) => {
	return {
		...getGlobalClasses(theme),
		pickerCardPaper: {
			height: '100%',
		},
		pickerCardPadding: {
			padding: 30,
		},
		pickCardTitleContainer: {
			paddingTop: 10,
			display: 'flex',
			alignContent: 'center',
			paddingBottom: 30,
		},
		pickerCardTitle: {
			paddingLeft: 10,
			fontSize: 28,
			color: '#333',
		},
		driverReportIcon: {
			width: 31,
		},
		pickerCardDescriptionLabel: {
			textTransform: 'uppercase',
			color: '#999',
			fontSize: 16,
		},
		pickerCardDescription: {
			fontSize: 18,
		},
		pickerCardButtonContainer: {
			textAlign: 'right',
			paddingTop: 30,
		},
		pickerCardButton: {
			paddingRight: 55,
			paddingLeft: 55,
			fontSize: 18,
		},
	};
};

const PickerCard = (props) => {
	const { classes, title, description, reportType, disabled } = props;
	return (
		<Paper className={classes.pickerCardPaper}>
			<div className={classes.pickerCardPadding}>
				<div className={classes.pickCardTitleContainer}>
					<img alt="driverReport" src={driverReportIcon} className={classes.driverReportIcon} />
					<span className={classes.pickerCardTitle}>{title}</span>
				</div>
				<div>
					<div className={classes.pickerCardDescriptionLabel}>Description</div>
					<div className={classes.pickerCardDescription}>{description}</div>

					<div className={classes.pickerCardButtonContainer}>
						<Link to={`/driver/report/add/${reportType}`} style={{ textDecoration: 'none' }}>
							<Button
								variant="contained"
								color="primary"
								aria-label="Add"
								size="large"
								className={classes.pickerCardButton}
								disabled={disabled}
							>
								Start
							</Button>
						</Link>
					</div>
				</div>
			</div>
		</Paper>
	);
};

class PickReport extends Component {
	render() {
		const { classes } = this.props;

		return (
			<Fragment>
				<div className={classes.globalMainHeadline}>Pick Report</div>

				<Grid container spacing={2}>
					<Grid item xs={12} sm={6}>
						<PickerCard
							classes={classes}
							reportType={'accident'}
							title={'Accident Report'}
							description={`Use this report if your vehicle has been in a collision,
							 or has sustained any damage as a result of contact with another vehicle, 
							 structure, object, person or animal.  This report requires photos of the accident.`}
						/>
					</Grid>
					<Grid item xs={12} sm={6}>
						<PickerCard
							classes={classes}
							reportType={'contamination'}
							title={'Contamination Report'}
							description={`Use this report if the delivery of fuel resulted in the
							contamination of a tank at a customer's site.`}
						/>
					</Grid>

					<Grid item xs={12} sm={6}>
						<PickerCard
							classes={classes}
							reportType={'injury'}
							title={'Injury Report'}
							description={`Use this report if you have sustained injuries or were hurt
					        while performing the duties of your job.`}
						/>
					</Grid>
					<Grid item xs={12} sm={6}>
						<PickerCard
							classes={classes}
							reportType={'spill'}
							title={'Spill Report'}
							description={`Use this report if during a delivery there was any fuel that was
							spilled or overflowed during the delivery process.`}
						/>
					</Grid>

					<Grid item xs={12} sm={6}>
						<PickerCard
							classes={classes}
							reportType={'incident'}
							title={'Incident Report'}
							description={`Use this report if you have a general incident that does not fall
							into the category of any of the other reports.`}
						/>
					</Grid>
					<Grid item xs={12} sm={6}>
						<PickerCard
							classes={classes}
							reportType={'nearMissReport'}
							title={'Near Miss Report'}
							description={`Use this report to self-report a near miss, including date/time, location, severity (0-10), details, and recommended solution.`}
						/>
					</Grid>
					<Grid item xs={12} sm={6}>
						<PickerCard
							classes={classes}
							reportType={'waitingForTruck'}
							title={'Waiting For Truck'}
							description={`Use this report if you had to wait for a truck and the details of the event`}
						/>
					</Grid>
				</Grid>
			</Fragment>
		);
	}
}

PickReport.propTypes = {
	classes: PropTypes.object.isRequired,
	authUser: PropTypes.object,
};

export default _.flow([withStyles(styles), requireClockIn])(PickReport);
